module.exports = __webpack_public_path__ + "static/media/got-coin-10.807d0d9a.png";